import { styled, Box, IconButton } from '@mui/material';

const DROPZONE_ITEM_SIZE = 130;
const DropzoneContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${DROPZONE_ITEM_SIZE}px, 1fr)
  );
  grid-gap: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(1);
}};
  position: relative;
  outline: none;
`;
const DropzoneDragArea = styled('div')`
  cursor: pointer;
  display: grid;
  justify-items: center;
  align-content: center;
  padding: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1);
}};
  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.palette.gray10;
}};
  border: 1px dashed;
  height: ${DROPZONE_ITEM_SIZE}px;
  grid-gap: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(0.5);
}};
`;
const DropzoneFileContainer = styled('div')`
  position: relative;
  height: ${DROPZONE_ITEM_SIZE}px;
`;
const DropzoneLoadingContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.palette.gray10;
}};
  opacity: 0.5;
  display: grid;
  justify-content: center;
  align-content: center;
`;
const DropzonePlaceholderContainer = styled(Box)`
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-content: center;
`;
const SingleDropzoneContainer = styled(Box)`
  cursor: pointer;
  display: grid;
  justify-items: center;
  align-content: center;
  width: 100%;
  min-height: ${DROPZONE_ITEM_SIZE}px;
  grid-column: 1 / 6;
  border: 1px dashed;
  background-color: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.palette.gray10;
}};
`;
styled(IconButton)`
  position: absolute;
  cursor: pointer;
  right: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(1);
}};
  top: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing(1);
}};
  background-color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return `${theme.palette.gray30}90`;
}};
  :hover {
    background-color: ${_ref0 => {
  let {
    theme
  } = _ref0;
  return theme.palette.gray30;
}};
  }
  transition: ${_ref1 => {
  let {
    theme
  } = _ref1;
  return theme.transitions.create(['background-color']);
}};
`;
const OptionsFileButton = styled(IconButton)`
  position: absolute;
  cursor: pointer;
  right: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.spacing(1);
}};
  top: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.spacing(1);
}};
  background-color: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return `${theme.palette.gray30}90`;
}};
  :hover {
    background-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.palette.gray30;
}};
  }
  transition: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.transitions.create(['background-color']);
}};
`;

export { DROPZONE_ITEM_SIZE, DropzoneContainer, DropzoneDragArea, DropzoneFileContainer, DropzoneLoadingContainer, DropzonePlaceholderContainer, OptionsFileButton, SingleDropzoneContainer };
